module.exports = __webpack_public_path__ + "assets/img/flyer.cdb17505.svg";